export enum MasterListType {
  analyticsMenu = 'analytics_menu',
  approve = 'approve',
  badges = 'badges',
  batchAlumniConfigure = 'batch_alumni_configure',
  batchEndInterval = 'batch_end_interval',
  centre = 'Centre',
  centreType = 'CentreType',
  course = 'course',
  createdPlatform = 'created_platform',
  district = 'District',
  educationalQualification = 'EducationalQualification',
  errorReportFilterBy = 'error_report_filter_by',
  errorReportType = 'error_report_type',
  experience = 'student_work_experience',
  facilitatorType = 'facilitator_type',
  faqCategory = 'FaqCategory',
  faqSubCategory = 'FaqSubCategory',
  gender = 'gender',
  industrySector = 'Field',
  interviewResult = 'interview_result',
  jobType = 'VacancyType',
  language = 'Language',
  lessonCategory = 'LessonCategory',
  lessonType = 'LessonType',
  location = 'Location',
  maritalStatus = 'marital_status',
  monthOfJoining = 'month_of_joining',
  mqopsPartnerType = 'MqopsPartnerType',
  notificationUserType = 'notification_user_type',
  offerLetterStatus = 'OfferletterStatus',
  offerLetterType = 'OfferletterType',
  organisation = 'Organisation',
  partnershipType = 'PartnershipType',
  phase = 'Phase',
  placementCourse = 'PlacementCourse',
  placementStatus = 'PlacementStatus',
  placementType = 'PlacementType',
  program = 'Program',
  project = 'Project',
  questAllianceEmployee = 'quest_alliance_employee',
  resourceCategory = 'ResourceCategory',
  salary = 'student_guardian_income',
  salaryRange = 'salary_range',
  sector = 'Sector',
  state = 'State',
  status = 'status',
  studentGuardianIncome = 'student_guardian_income',
  studentWorkExperience = 'student_work_experience',
  subject = 'Subject',
  tenant = 'Tenant',
  trade = 'Trade',
  type = 'user_type',
  workingMode = 'working_mode',
}
